// Forms: Actions to get data from React Hook Forms.
import { actionTypes } from './types';

type Action<T> = import('./types').Action<T>;

// Calculator - Vehicle Info
export interface FormTypeCalculatorVehicleInfo {
    vehicleRegistrationNumber: string;
    odometerValue?: any;
}

export interface FormTypeEuroTaxVehicleInfo {
    regNr?: string | null;
    vehiclePrice?: number | null;
    equity?: number;
    loanPeriodInMonths?: number;
    odometerValue?: number;
}

export interface FormTypeLoanSearchForm {
    regNr: string;
}

// Calculator - Loan Info
export interface FormTypeCalculatorLoanInfo {
    vehiclePrice: number;
    equity: number;
    loanAmountWithoutFees: number;
    requestedLoanPeriodInMonths: number;
    manufacturer?: string;
}

// Loan Application - Main Applicant
export interface FormTypeApplicationMainApplicant {
    email: string;
    phone: string;
    employmentConditionCode: string;
    livingConditionCode: string;
    rentalFee?: number;
    grossIncome?: number;
    totalDebt?: number;
    tradeIn: boolean;
    tradeInDebt?: number;
}

// Loan Application - Co Applicant
export interface FormTypeApplicationCoApplicant {
    hasCoApplicant?: boolean;
    confirmAddress?: boolean;
    ssn?: string;
    email: string;
    phone: string;
    employmentConditionCode: string;
    livingConditionCode: string;
    rentalFee?: number;
    grossIncome?: number;
    totalDebt: number;
    tradeIn: boolean;
    tradeInDebt?: number;
}

// Loan Completion - Details
export interface FormTypeCompletionDetails {
    email?: string;
    phone?: string;
}

// Action types
export interface UpdateLoanTypeAction extends Action<typeof actionTypes.UPDATE_LOAN_TYPE> {
    type: typeof actionTypes.UPDATE_LOAN_TYPE;
    payload: string;
}

export interface ToggleCoApplicantAction extends Action<typeof actionTypes.TOGGLE_CO_APPLICANT> {
    type: typeof actionTypes.TOGGLE_CO_APPLICANT;
    payload: boolean;
}

export interface FormTypeCalculatorVehicleInfoAction extends Action<typeof actionTypes.FORM_VEHICLE_INFO> {
    type: typeof actionTypes.FORM_VEHICLE_INFO;
    payload: FormTypeCalculatorVehicleInfo;
}

export interface FormCalculatorLoanInfoAction extends Action<typeof actionTypes.FORM_LOAN_INFO> {
    type: typeof actionTypes.FORM_LOAN_INFO;
    payload: FormTypeCalculatorLoanInfo;
}

export interface FormApplicationMainApplicantAction extends Action<typeof actionTypes.FORM_APPLICATION_MAIN_APPLICANT> {
    type: typeof actionTypes.FORM_APPLICATION_MAIN_APPLICANT;
    payload: FormTypeApplicationMainApplicant;
}

export interface FormApplicationCoApplicantAction extends Action<typeof actionTypes.FORM_APPLICATION_CO_APPLICANT> {
    type: typeof actionTypes.FORM_APPLICATION_CO_APPLICANT;
    payload: FormTypeApplicationCoApplicant;
}

export interface FormCompletionDetailsAction extends Action<typeof actionTypes.FORM_COMPLETION_DETAILS> {
    type: typeof actionTypes.FORM_COMPLETION_DETAILS;
    payload: FormTypeCompletionDetails;
}

export type FormActions =
    | UpdateLoanTypeAction
    | ToggleCoApplicantAction
    | FormTypeCalculatorVehicleInfoAction
    | FormCalculatorLoanInfoAction
    | FormApplicationMainApplicantAction
    | FormApplicationCoApplicantAction
    | FormCompletionDetailsAction;

// Actions
export const updateLoanType = (loanType: string): UpdateLoanTypeAction => ({
    type: actionTypes.UPDATE_LOAN_TYPE,
    payload: loanType,
});
export const toggleCoApplicant = (hasCoApplicant: boolean): ToggleCoApplicantAction => ({
    type: actionTypes.TOGGLE_CO_APPLICANT,
    payload: hasCoApplicant,
});

// React Hook Forms
export const formCalculatorVehicleInfo = (
    form: FormTypeCalculatorVehicleInfo,
): FormTypeCalculatorVehicleInfoAction => ({
    type: actionTypes.FORM_VEHICLE_INFO,
    payload: form,
});
export const formCalculatorLoanInfo = (form: FormTypeCalculatorLoanInfo): FormCalculatorLoanInfoAction => ({
    type: actionTypes.FORM_LOAN_INFO,
    payload: form,
});
export const formApplicationMainApplicant = (
    form: FormTypeApplicationMainApplicant,
): FormApplicationMainApplicantAction => ({
    type: actionTypes.FORM_APPLICATION_MAIN_APPLICANT,
    payload: form,
});
export const formApplicationCoApplicant = (form: FormTypeApplicationCoApplicant): FormApplicationCoApplicantAction => ({
    type: actionTypes.FORM_APPLICATION_CO_APPLICANT,
    payload: form,
});
export const formCompletionLoanDetails = (form: FormTypeCompletionDetails): FormCompletionDetailsAction => ({
    type: actionTypes.FORM_COMPLETION_DETAILS,
    payload: form,
});
